import React, { forwardRef, LegacyRef } from "react";

const GeniusNoAccessMathSvg = forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: LegacyRef<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        width="128"
        height="109"
        viewBox="0 0 128 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M42.9446 48.4062C35.4879 49.5477 30.6656 49.7418 25.3503 52.1837C18.1129 56.5902 11.093 61.6721 6.07467 68.4972C1.0563 75.3224 -1.31797 83.6072 0.741798 91.8261C3.03258 100.973 16.457 108.825 26.3966 108.825C35.2259 108.825 35.9966 108.763 44.8239 108.825H47.0059C47.0059 108.825 46.5652 98.1892 46.8933 94.1924C39.1183 92.9267 31.1413 89.5452 24.6611 85.065L27.9031 81.0837C27.9031 81.0837 27.6061 86.8121 27.8973 86.8373C37.1342 92.2609 50.3839 96.1025 58.5705 94.3826C61.1486 93.841 64.3596 93.8992 67.7492 93.8992L72.7015 95.6541V92.3995L76.0309 90.7022C76.0309 90.7022 91.7787 76.7033 87.7487 70.0761C87.7487 70.0761 78.8164 56.7586 74.0622 53.5763C72.115 52.0195 68.7024 50.9705 66.2233 50.691L49.883 48.8547L42.9446 48.4062Z"
          fill="#11ACDB"
        />
        <path
          d="M47.0298 94.3432C47.0298 94.3432 53.5934 94.9993 53.6323 94.9934C58.3963 94.1743 63.24 93.8249 68.072 93.9569L74.3988 96.2222L71.8285 105.977L46.7852 106.701L47.0298 94.3432Z"
          fill="#A55D2B"
        />
        <path
          d="M19.9414 82.0469C28.0329 88.1518 37.5688 92.1467 47.59 94.3519C49.9448 94.8702 52.3676 95.0177 54.7671 94.7828C59.3099 94.3383 63.8274 93.7424 67.7508 93.9093C69.5136 94.4218 72.346 95.6117 74.1087 96.1242"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.3242 96.2422C70.0287 96.8711 71.7313 97.502 73.4358 98.1309"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.8308 100.525C70.8526 99.7098 68.4841 98.8925 66.6127 97.9161C66.5797 97.8171 66.5467 97.7181 66.5156 97.6172"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.7633 104.06C69.1484 103.055 66.5314 102.051 64.0077 101.049C63.8931 100.76 63.7786 100.469 63.6641 100.18"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5586 85.0208C26.6125 82.4488 28.6665 79.8767 30.7224 77.3047"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.947 80.7812C27.9217 82.5244 27.9237 85.3973 27.8984 87.1405"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.18 78.5391C48.3302 83.326 43.2574 85.1215 38.3672 84.0422"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.75 60.1641C71.4077 63.4776 74.1275 66.9135 75.2787 71.0016C76.43 75.0896 75.6146 80.0435 72.2114 82.5844L72.3687 95.3379"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.888 94.1797L46.7812 105.943"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.4744 35.6315C49.114 35.9201 50.6772 34.825 50.9658 33.1855C51.2544 31.546 50.1592 29.983 48.5196 29.6944C46.88 29.4058 45.3168 30.5009 45.0282 32.1404C44.7396 33.7799 45.8348 35.3429 47.4744 35.6315Z"
          fill="black"
        />
        <path
          d="M44.6335 49.4535C45.1239 46.2612 47.4339 32.2105 47.4339 32.2105C45.702 32.5225 44.14 32.1215 42.9464 30.8276C41.7529 29.5337 41.9159 28.8979 42.3658 27.1946C42.815 25.4946 42.961 24.065 44.637 23.5284L53.5703 16.56C55.9249 15.8668 58.5494 16.1379 60.7138 17.2994C62.8782 18.4608 64.1137 18.5218 64.8358 20.8676C65.6123 25.1381 62.8523 34.8323 62.8523 34.8323C61.9041 37.3919 59.5744 39.57 56.8763 39.988C56.7228 40.2404 56.0295 44.2171 56.0295 44.2171L55.0405 51.074C54.2057 51.4212 52.2186 52.1178 49.6845 51.7399C47.0638 51.3502 45.3258 50.0321 44.6412 49.4481L44.6335 49.4535Z"
          fill="#A55D2B"
        />
        <path
          d="M52.9084 21.8452C54.5984 20.6613 55.4198 18.9188 54.7433 17.9532C54.0667 16.9876 52.1482 17.1646 50.4583 18.3485C48.7684 19.5324 47.9469 21.2749 48.6235 22.2405C49.3001 23.2061 51.2185 23.0291 52.9084 21.8452Z"
          fill="black"
        />
        <path
          d="M44.9297 27.2656C45.6441 27.7765 46.1926 28.5138 46.4792 29.3447"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.443 26.1225C46.5747 24.6268 42.8518 24.4385 42.2419 27.9028C41.8013 30.4052 43.9154 32.9177 47.2064 32.1712"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.6808 38.9839C52.909 40.0543 55.553 40.4277 57.8579 39.6099C58.4359 39.4049 59.0036 39.1231 59.5443 38.782C61.7296 37.4047 62.7859 35.6445 63.404 32.7337C64.0221 29.8229 65.9893 21.3591 64.3805 20.333"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.9297 25.5703C49.0367 26.4263 49.054 28.3414 47.966 29.2166C48.723 29.1181 49.5065 29.682 49.6537 30.4338C49.8008 31.1857 49.2856 32.0016 48.546 32.1952C49.1718 32.6291 49.521 33.4335 49.4126 34.1847C49.3042 34.9358 48.7423 35.6106 48.0188 35.8479"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.5208 38.9814C51.7837 41.1974 53.7413 43.0109 56.0471 44.1052C56.0471 44.1052 56.6621 40.3793 56.7267 40.0124C54.6677 40.3043 52.5023 39.8073 50.5241 38.982L50.5208 38.9814Z"
          fill="black"
        />
        <path
          d="M45.3102 33.3126C46.0241 33.4382 46.7047 32.9614 46.8304 32.2476C46.9561 31.5337 46.4792 30.8532 45.7653 30.7275C45.0514 30.6019 44.3708 31.0787 44.2451 31.7925C44.1194 32.5064 44.5963 33.1869 45.3102 33.3126Z"
          fill="#FDE7C7"
        />
        <path
          d="M59.7434 32.0255C59.2632 31.4809 58.9477 30.7948 58.8305 30.0278C58.6987 29.1696 58.8529 28.2936 59.2139 27.5017C59.4313 27.0219 59.6851 26.6065 59.9976 26.2253C61.3142 24.6132 63.8056 24.8848 64.4912 26.4505"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.8831 24.1811C56.37 23.1343 54.2272 23.4184 52.9293 24.5566"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.0927 29.695C62.5528 29.776 63.0103 29.3621 63.1144 28.7706C63.2185 28.1791 62.93 27.6339 62.4698 27.5529C62.0097 27.4719 61.5523 27.8858 61.4482 28.4773C61.344 29.0688 61.6326 29.614 62.0927 29.695Z"
          fill="black"
        />
        <path
          d="M52.5083 30.1907L56.3462 32.9009C56.3462 32.9009 54.5572 34.2151 53.175 33.3345C52.3289 32.797 51.7004 31.2754 52.511 30.1946L52.5083 30.1907Z"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.4404 28.5309C55.9005 28.6119 56.3579 28.198 56.462 27.6065C56.5662 27.015 56.2776 26.4698 55.8175 26.3888C55.3574 26.3078 54.9 26.7217 54.7958 27.3132C54.6917 27.9048 54.9803 28.4499 55.4404 28.5309Z"
          fill="black"
        />
        <path
          d="M56.7773 39.8984L55.1134 50.5218"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.9309 20.8746C65.3988 20.0947 66.3285 19.9448 67 20.08C67.6715 20.2152 68.177 20.887 68.1686 21.574C68.1601 22.2609 67.6664 22.8965 67.0192 23.1268C67.3946 22.8146 68.0264 22.8849 68.3264 23.2717C68.6264 23.6585 68.5363 24.2868 68.1379 24.5745C68.8792 24.0813 69.9799 24.2376 70.5554 24.9183C71.1309 25.5989 71.0987 26.7111 70.4874 27.3567"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4207 11.2621C54.9971 11.2409 55.4983 10.6781 55.4528 10.1044C55.4072 9.53059 54.8305 9.05077 54.2565 9.11674C55.4042 8.83139 56.4271 7.90038 56.5955 6.73037C56.764 5.56036 55.8855 4.27763 54.7051 4.20619"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.3377 3.8441C41.7557 3.14184 40.7147 2.85976 39.8586 3.17259C39.0026 3.48542 38.3896 4.37271 38.4023 5.28831C37.8572 4.89928 37.1169 4.80646 36.491 5.05074C35.8652 5.29503 35.3832 5.86455 35.2442 6.51831"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.5928 25.1069C47.1906 25.8858 47.3108 25.4741 47.3209 26.4233C47.8513 26.7791 48.5799 26.5325 48.7818 25.9273C49.1273 24.8941 49.5529 23.6773 50.2713 22.0554C50.8759 20.6929 52.1145 19.6976 53.5849 19.4384C57.3415 18.7772 61.5952 19.1068 65.0864 21.289C65.3058 15.803 61.515 12.5729 57.1681 11.0886C52.8212 9.60439 47.6796 10.775 44.4058 13.9988C41.1319 17.2226 38.2709 23.2899 42.2364 29.1478C42.2376 28.1733 42.2863 26.5221 43.3279 25.833C44.3695 25.1438 45.1318 24.8793 45.5994 25.1081L45.5928 25.1069Z"
          fill="black"
        />
        <path
          d="M54.4716 11.4911C54.7345 11.1012 54.7543 10.5627 54.5274 10.1479C54.3005 9.73308 53.8321 9.47001 53.37 9.36482C54.0566 8.81427 54.3269 7.8019 54.0043 6.9817C53.6817 6.16151 52.795 5.60326 52.0097 5.90128C52.1606 5.39276 52.0444 4.81338 51.7121 4.39704C51.3798 3.98069 50.8383 3.74565 50.4975 3.90037C50.337 3.16663 49.7843 2.53086 49.0802 2.27061C48.3762 2.01036 47.5434 2.13302 47.2163 2.53895C46.4578 1.83288 45.3284 1.5489 44.3238 1.81512C43.3192 2.08135 42.4763 2.88046 42.2362 3.79928C41.5791 3.40757 40.6942 3.43926 40.0628 3.87001C39.4313 4.30077 39.0867 5.116 39.1384 5.81012C38.4153 5.69649 37.6425 6.02056 37.2177 6.61378C36.7928 7.207 36.7339 8.04525 37.102 8.64513C36.5094 8.70099 35.9625 9.11596 35.7549 9.67584C35.5473 10.2357 35.6846 10.9074 36.2761 11.2842C35.649 11.7293 35.4007 12.6365 35.71 13.3385C36.0193 14.0405 36.8582 14.4642 37.6281 14.1567C36.993 14.6277 36.7532 15.5636 37.0866 16.2835C37.42 17.0033 38.2821 17.4311 39.1271 17.1811C39.1354 18.0244 39.6804 18.8394 40.4572 19.1704C41.234 19.5014 42.1986 19.327 42.8121 18.7465L54.4716 11.4911Z"
          fill="black"
        />
        <path
          d="M46.6533 25.2152C46.6056 21.4204 49.3526 16.7167 53.7135 15.8757C56.8538 15.2696 61.2056 15.1188 64.3141 17.036C63.0954 14.3165 61.3404 12.7466 59.201 12.353C55.1743 11.6442 51.8369 11.8986 48.9077 13.9971C45.9785 16.0955 43.4494 20.6263 43.6677 25.3884C44.5052 24.9291 45.7461 24.6568 46.6566 25.2158L46.6533 25.2152Z"
          fill="#70CDE9"
        />
        <path
          d="M41.8953 49.1959L42.1224 45.7464C42.2001 44.5604 43.2251 43.6597 44.4132 43.7393L56.7738 44.5507C57.9599 44.6283 58.8607 45.6533 58.7811 46.8412L58.554 50.2907C58.4763 51.4767 57.4513 52.3774 56.2632 52.2978L43.9027 51.4864C42.7165 51.4088 41.8176 50.3839 41.8953 49.1959Z"
          fill="#11ACDB"
        />
        <path
          d="M56.9391 50.2935C52.6041 50.3323 48.2671 49.9344 44.0117 49.1094"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9808 77.3438C30.4217 80.8572 29.7927 84.3688 29.2336 87.8823L27.8125 86.9408L28.0862 80.7544L30.9808 77.3438Z"
          fill="black"
        />
        <path
          d="M41.6133 48.5312C41.9996 52.9435 45.8668 56.7928 50.2833 57.1558C54.6999 57.5188 58.1807 54.1994 59.2814 49.9095"
          stroke="#70CDE9"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M87.7539 108.897H33.1934V107.898C33.1934 106.073 34.6729 104.594 36.4976 104.594H87.7539V108.897Z"
          fill="black"
        />
        <path
          d="M66.5871 108.902H116.199L127.099 75.956C128.152 72.7721 125.781 69.4922 122.429 69.4922H83.1803C81.0585 69.4922 79.1768 70.8515 78.5106 72.8651L66.5871 108.902Z"
          fill="black"
        />
        <path
          d="M96.7298 90.6514C96.2865 88.7739 97.4492 86.8926 99.3268 86.4493C101.204 86.0059 103.086 87.1686 103.529 89.046C103.973 90.9234 102.81 92.8047 100.932 93.248C99.0547 93.6913 97.1732 92.5288 96.7298 90.6514Z"
          fill="white"
        />
        <path
          d="M100.159 93.9306C102.35 93.9306 104.133 92.148 104.133 89.9574C104.133 87.7668 102.35 85.9844 100.159 85.9844C97.9685 85.9844 96.1858 87.7668 96.1858 89.9574C96.1888 92.148 97.9685 93.9306 100.159 93.9306ZM100.159 86.9446C101.822 86.9446 103.175 88.298 103.175 89.9605C103.175 91.623 101.822 92.9763 100.159 92.9763C98.4967 92.9763 97.1432 91.623 97.1432 89.9605C97.1462 88.295 98.4967 86.9446 100.159 86.9446Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default GeniusNoAccessMathSvg;
